
import { computed, defineComponent, onMounted } from "vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import { storeToRefs } from "pinia";
import { useVaultStore } from "@/stores/vault";
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default defineComponent({
  name: "vault-summary",
  setup() {
    const vault = useVaultStore();
    const {
      summaryAvailable,
      summaryAssigned,
      summaryTotal,
      summaryBtcPrice,
      summaryUpdatedDate,
      isSummaryLoading,
    } = storeToRefs(vault);

    const formatDateTimezone = (milliseconds: number) =>
      dayjs(milliseconds).format("YYYY/MM/DD HH:mm:ss z");

    const availableUSD = computed(() => {
      const availableNum = parseFloat(summaryAvailable.value ?? "0");
      const usdValue = availableNum * (summaryBtcPrice.value || 0);
      return usdValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    });

    const assignedUSD = computed(() => {
      const assignedNum = parseFloat(summaryAssigned.value ?? "0");
      const usdValue = assignedNum * (summaryBtcPrice.value || 0);
      return usdValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    });

    const totalUSD = computed(() => {
      const totalNum = parseFloat(summaryTotal.value ?? "0");
      const usdValue = totalNum * (summaryBtcPrice.value || 0);
      return usdValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    });

    const formattedBTCPrice = computed(() =>
      (summaryBtcPrice.value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );

    const formattedUpdatedDate = computed(() =>
      summaryUpdatedDate.value
        ? formatDateTimezone(new Date(summaryUpdatedDate.value).getTime())
        : ""
    );

    const getSummaryData = () => vault.refreshSummary();

    onMounted(() => {
      vault.fetchSummary();
    });

    return {
      summaryAvailable,
      summaryAssigned,
      summaryTotal,
      summaryBtcPrice,
      summaryUpdatedDate,
      isSummaryLoading,
      availableUSD,
      assignedUSD,
      totalUSD,
      formattedBTCPrice,
      formattedUpdatedDate,
      formatDateTimezone,
      getSummaryData,
    };
  },
});
